import {RouteLocationRaw} from 'vue-router'
import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {RouteQueryKey} from '@toolify/client/src/setup/router/enum/RouteQueryKey'

export function getUnavailableWorkspaceRedirect(workspaceName: string): RouteLocationRaw {
  return {
    name: RouteName.ChooseWorkspace,
    query: {
      [RouteQueryKey.UnavailableWorkspace]: workspaceName,
    },
  }
}
